import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MapState } from './map.reducer';

export const selectMapState = createFeatureSelector<MapState>('map');

export const selectMapPosition = createSelector(selectMapState, (state: MapState, mapId: string) => state[mapId]);
